import { Box, styled, Typography } from "@mui/material";

export const CardInfoWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(3),
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
}));

export const DetailCardContainer = styled(Box)(({ theme }) => ({
  flex: 0,
  width: 'auto',
  [theme.breakpoints.up('lg')]: {
    flex: 1,
    width: '60%',
  },
}));

export const BookingDetailsCard = styled(Box)(({ theme }) => ({
  fontFamily: 'monospace',
  backgroundColor: theme.palette.paper.light,
  border: `2px dashed ${theme.palette.primary.main}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
  width: 'auto',
  boxShadow: '2px 2px 8px rgba(0,0,0,0.1)',
  alignSelf: 'stretch',
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(2),
    width: '40%',
    alignSelf: 'flex-start',
  },
}));

export const BookingTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'monospace',
  textAlign: 'center',
  borderBottom: `1px solid ${theme.palette.primary.main}`,
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
  color: theme.palette.primary.main,
  fontWeight: 'bold',
}));

export const InfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const MonospaceText = styled(Typography)(({ theme }) => ({
  fontFamily: 'monospace',
  color: theme.palette.text.primary,
  lineHeight: 1.4,
}));

export const BookingFooter = styled(Typography)(({ theme }) => ({
  fontFamily: 'monospace',
  textAlign: 'center',
  display: 'block',
  marginTop: theme.spacing(1.5),
  paddingTop: theme.spacing(1),
  borderTop: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
}));
